"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TabsControlled from "./TabsControlled.js";
const TabsUncontrolled = (props) => {
    const { defaultValue, onChange } = props;
    const [value, setValue] = React.useState(defaultValue);
    const handleChange = ({ value }) => {
        setValue(value);
        if (onChange)
            onChange({ value });
    };
    // Silently handle the default id selection if it's not passed
    const handleSilentChange = ({ value }) => {
        setValue(value);
    };
    return (_jsx(TabsControlled, { ...props, onChange: handleChange, onSilentChange: handleSilentChange, value: value, defaultValue: undefined }));
};
TabsUncontrolled.displayName = "TabsUncontrolled";
export default TabsUncontrolled;
